module.exports = __webpack_public_path__ + "static/media/addgreen.87abd940.svg";